<template>
  <div class="wg-row">
    <!-- Form -->
    <form @submit.prevent="save" style="width: 100%">
      <customer-details :contact="contact" v-model="customerDetails"></customer-details>
      <div class="vertical-height-div" style="height: 20px"></div>
      <div class="wg-row com-anm22-app-text-xxl">
        {{ $anm22.strLang(lang, "Modules", "Moduli") }}
      </div>
      <div class="vertical-height-div" style="height: 10px"></div>
      <div
        v-for="(module, name) in config.modules"
        :key="'module-' + name"
        class="wg-row"
        style="flex-wrap: nowrap; align-items: center; margin-top: 10px"
      >
        <div class="wg-col wg-xs-4">
          <div class="com-anm22-app-text-l" style="margin: 0 5px">
            {{ labels[name] }}
          </div>
        </div>
        <input
          :id="'app-checkbox-' + name"
          type="checkbox"
          style="display: none"
          v-model="module.enabled"
        />
        <label class="label-input-radio" :for="'app-checkbox-' + name">{{
          module.enabled ? "✔" : ""
        }}</label>
      </div>
      <div class="vertical-height-div" style="height: 20px"></div>
      <div class="wg-row">
        <button 
            type="submit"
            :style="{ opacity: canGenerateContract ? '' : '0.6' }"
            :disabled="!canGenerateContract"
        >
          <div>{{ $anm22.strLang(lang, 'Save and generate license', 'Salva e genera licenza') }}</div>
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import _ from "lodash";
import CustomerDetails from './CustomerDetails.vue';
import { mapState } from "vuex";
export default {
  components: {
    CustomerDetails
  },
  props: {
    projectId: [Number, String],
    contact: Object,
  },
  data() {
    return {
      customerDetails: {},
      config: {
        modules: {
          menu: {
            enabled: true,
          },
          fastCash: {
            enabled: true,
          },
          fiscal: {
            enabled: true,
          },
          invoices: {
            enabled: true,
            pro: true, // automated sending
          },
          tables: {
            enabled: true,
          },
          sequences: {
            enabled: true,
          },
          delivery: {
            enabled: true,
          },
          analytics: {
            enabled: true,
          },
        },
      },
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      windowWidth: (state) => state.windowWidth,
      offline: (state) => state.offline.isOffline,
    }),
    canGenerateContract() {
      let canGenerate = true;
      if (!this.customerDetails.name || this.customerDetails.name == "") {
        canGenerate = false;
      }
      if (!this.customerDetails.addressStreet || this.customerDetails.addressStreet == "") {
        canGenerate = false;
      }
      if (!this.customerDetails.addressCity || this.customerDetails.addressCity == "") {
        canGenerate = false;
      }
      if (!this.customerDetails.addressZip || this.customerDetails.addressZip == "") {
        canGenerate = false;
      }
      if (!this.customerDetails.addressState || this.customerDetails.addressState == "") {
        canGenerate = false;
      }
      if (!this.customerDetails.addressCountry || this.customerDetails.addressCountry == "") {
        canGenerate = false;
      }
      if (
        (!this.customerDetails.email || this.customerDetails.email == "") &&
        (!this.customerDetails.email2 || this.customerDetails.email2 == "") &&
        (!this.customerDetails.email3 || this.customerDetails.email3 == "")
      ) {
        canGenerate = false;
      }
      let phone1 = null;
      let phone2 = null;
      let phone3 = null;
      if (this.customerDetails.phoneAreaCode == "" || this.customerDetails.phoneNumber == "") {
        phone1 = null;
      } else {
        phone1 = this.customerDetails.phoneAreaCode + this.customerDetails.phoneNumber;
      }
      if (
        this.customerDetails.phoneAreaCode2 == "" ||
        this.customerDetails.phoneNumber2 == ""
      ) {
        phone2 = null;
      } else {
        phone2 = this.customerDetails.phoneAreaCode2 + this.customerDetails.phoneNumber2;
      }
      if (
        this.customerDetails.phoneAreaCode3 == "" ||
        this.customerDetails.phoneNumber3 == ""
      ) {
        phone3 = null;
      } else {
        phone3 = this.customerDetails.phoneAreaCode3 + this.customerDetails.phoneNumber3;
      }
      if (!phone1 && !phone2 && !phone3) {
        canGenerate = false;
      }
      return canGenerate;
    },
    labels() {
      return {
        menu: this.$anm22.strLang(this.lang, 'Digital menu', 'Menù digitale'),
        fastCash: this.$anm22.strLang(this.lang, 'Register', 'Cassa rapida'),
        tables: this.$anm22.strLang(this.lang, 'Tables management', 'Gestione tavoli'),
        sequences: this.$anm22.strLang(this.lang, 'Sequences management', 'Gestione comande'),
        delivery: this.$anm22.strLang(this.lang, 'Delivery', 'Consegna'),
        analytics: this.$anm22.strLang(this.lang, 'Advanced analytics', 'Statistiche avanzate'),
        fiscal: this.$anm22.strLang(this.lang, 'Fiscal print', 'Stampa scontrino fiscale'),
        invoices: this.$anm22.strLang(this.lang, 'Invoicing', 'Fatturazione'),
      }
    },
  },
  methods: {
    async save() {
      try {
        const response = await this.$http.post(
          "spiagge/generate-yf-license",
          {
            contact: this.contact,
            projectId: this.projectId,
            config: this.config,
            customerDetails: this.customerDetails
          },
          {
            withCredentials: true,
          }
        );
        if(response.data && !response.data.error) {
          Promise.all([
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: [response.data.contact],
            }),
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: response.data.projects,
            }),
          ])
            .then(() => {
              // Open licenza
              window.open(response.data.url, "_blank");
              this.$anm22.eventBus.$emit("wg-modal-close");
            });
        } else {
          this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: response.data.error,
            type: "alarm"
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  created() {
    
  },
};
</script>
 
<style lang="scss" scoped>
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  height: 36px;
}

.license-item {
  color: #222;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  width: 266px;
  text-align: center;
  display: inline-block;
  margin: 10px;
  border-radius: 6px;
}
.license-item:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.2);
}
.license-img {
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 118px;
  border-radius: 6px 6px 0 0;
}
.license-img img {
  border-radius: 6px 6px 0 0;
}
.license-data {
  background-color: #fff;
  padding: 10px 10px 5px 10px;
  overflow: hidden;
  border-radius: 0 0 6px 6px;
}
.license-title {
  color: #222;
  font-size: 16px;
  margin: 0 0 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.license-subtitle {
  color: #777;
  font-size: 16px;
}
</style>
 